<template>
  <v-sheet class="pa-2">
    <v-row>
      <v-col>
        <Tooltip content="Select key name from keyboard" top>
          <v-select
            :items="options"
            label="Type of variable"
            v-model="selectedEnv"
            prepend-icon="mdi-tune-varient"
            outlined
          >
          </v-select>
        </Tooltip>
      </v-col>
      <v-col v-if="selectedEnv === 'global'">
        <Tooltip content="Overwrite existing variable value" top>
          <v-autocomplete
            :items="globalEnv"
            label="Search Global variable"
            v-model="env"
            prepend-icon="mdi-arrow-right"
            outlined
            @change="changed"
          >
          </v-autocomplete>
        </Tooltip>
      </v-col>
      <v-col v-if="selectedEnv === 'local'">
        <Tooltip content="Set new local variable's value (use lower-case letters with '_' if needed - e.g use suffix 'my_new_var'" top>
          <v-text-field
            label="Set Local variable"
            v-model="env"
            prepend-icon="mdi-arrow-right"
            outlined
            @input="changed"
          >
          </v-text-field>
        </Tooltip>
      </v-col>
    </v-row>
    <!-- <v-row class="my-0"> -->
    <p class="px-1 blue--text">
      This field is for setting a new/existing environment variable to the test
      with the returned value of the step results. <br />
      * the value of the variable will be available for the children and further
    </p>
    <!-- </v-row> -->
  </v-sheet>
</template>

<script lang="ts">
import Vue from "vue";
import VueTypes from "vue-types";
import { ListObj, SelectItem } from "../types";
import Tooltip from "@/components/Tooltip.vue";

export default Vue.extend({
  components: { Tooltip },
  name: "EnvComp",

  data() {
    return {
      // variable: { value: "", text: "" },
      selectedEnv: "local",
      options: [
        { text: "New Variable", value: "local" },
        { text: "Existing Variable", value: "global" },
      ],
      local: [],
    };
  },
  props: {
    value: VueTypes.any.def([]),
  },
  methods: {
    changed(val: SelectItem | undefined) {
      const env = [
        {
          name: val || "",
          type: "text",
          val,
        },
      ];
      this.$emit("input", { env });
    },
  },
  computed: {
    globalEnv(): ListObj {
      const globalEnv = this.$store.getters["Plans/getCurrentPlanGlobalEnv"];
      return globalEnv
        .filter((e: ListObj) => e.type === "text")
        .map((e: ListObj) => {
          const { name } = e;
          return "${{ " + name + " }}";
        });
    },
    env: {
      get(): string {
        return this.value.map((e: ListObj) => e.name)[0];
      },
      set(val: SelectItem | undefined) {
        this.changed(val);
      },
    },
  },
});
</script>
